import { styled } from '@mui/material';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash-es';
// import { useState } from 'react';
import { HiOutlineArchive } from 'react-icons/hi';
import { TbCurrentLocation } from 'react-icons/tb';
import { DiceSearch, DiceSearchResponse } from 'wisestep-api';
import {
  WsDetailsObj,
  WsIconLocation,
  WsIconJobOutline,
  WsIconPersons,
  WsIconTime,
  WsIconVisa,
  WsColors,
  IFilterList,
  WsIconLikeLocation,
  WsIconCurrency,
  WsIconPosition,
} from 'wisestep-base';

import { SmallBoxWithRadius } from '../../../../features/candidates/utils/CandidateHelper';
import IDiceAdvanceSearch from '../types/IDiceAdvanceSearch';

import {
  getCandidateLocation,
  getWillingToRelocate,
  getWorkPreference,
  getRate,
  getTravelPreference,
} from './processDiceCandidate';

export const getBotCandidateDetails = (candidate): WsDetailsObj[] => {
  const array: WsDetailsObj[] = [];
  array.push({
    icon: <WsIconLocation />,
    labelName:
      `${
        (candidate.city ? candidate.city : '') +
        ',' +
        (candidate.country ? candidate.country : '') +
        ',' +
        (candidate.region ? candidate.region : '')
      }` ?? 'Not Available',
    popOverText: 'Candidate Location',
  });
  array.push({
    icon: <WsIconJobOutline />,
    labelName: candidate.currentJobTitle ?? 'Not Available',
    popOverText: 'Candidate Profile',
  });
  array.push({
    icon: <WsIconPersons />,
    labelName:
      (candidate.yearsOfExperience && `${candidate.yearsOfExperience} Year Experience`) ??
      'Not Available',
    popOverText: 'Candidate Experience',
  });
  array.push({
    icon: <WsIconTime />,
    labelName: candidate?.workPreferences?.[0].employmentType.toString() ?? 'Not Available',
    popOverText: 'Candidate Working Time',
  });
  array.push({
    icon: <WsIconVisa />,
    labelName:
      (candidate.workPermitLocations && candidate.workPermitLocations.join('|')) ?? 'Not Available',
    popOverText: 'Candidate Visa',
  });
  return array;
};

export const SmallBoxWithBgColor = styled(SmallBoxWithRadius)(() => ({
  background: WsColors.TheBlues400,
  borderRadius: 4,
  border: '0px',
}));

export const pushSearchFilters = (data: IDiceAdvanceSearch) => {
  const filtersArray: IFilterList[] = [];
  const formattedDate = (date: string): string => dayjs(date).format('DD/MM/YYYY');
  if (!isEmpty(data.jobTitle.values))
    filtersArray.push({
      tag: `Job Titles: ${data.jobTitle.values.join(',')}`,
      id: 'jobTitle',
    });
  if (!isEmpty(data.additionalFilters))
    filtersArray.push({
      tag: `Additional Filters: ${data.additionalFilters.join(',')}`,
      id: 'additionalFilters',
    });
  if (!isEmpty(data.authorizedCountries))
    filtersArray.push({
      tag: `Authorized: ${data.authorizedCountries.join(',')}`,
      id: 'authorizedCountries',
    });
  if (!isEmpty(data.companies.values))
    filtersArray.push({
      tag: `Companies: ${data.companies.values.join(',')}`,
      id: 'companies',
    });
  if (!isEmpty(data.contactMethod))
    filtersArray.push({
      tag: `Contact: ${data.contactMethod.join(',')}`,
      id: 'contactMethod',
    });
  if (!isEmpty(data.education))
    filtersArray.push({
      tag: `Education: ${data.education.join(',')}`,
      id: 'education',
    });
  if (!isEmpty(data.employmentType))
    filtersArray.push({
      tag: `Employment: ${data.employmentType.join(',')}`,
      id: 'employmentType',
    });
  if (data.excludeSocialOnlyProfiles)
    filtersArray.push({
      tag: 'Exclude Social Only Profiles',
      id: 'excludeSocialOnlyProfiles',
    });
  if (data.hasSecurityClearance)
    filtersArray.push({
      tag: 'Has Security Clearance',
      id: 'hasSecurityClearance',
    });
  if (!isEmpty(data.languages))
    filtersArray.push({
      tag: `Languages: ${data.languages.join(',')}`,
      id: 'languages',
    });
  if (data.likelyToMove.toString() !== '-1')
    filtersArray.push({
      tag: `Likely to Move: ${data.likelyToMove}`,
      id: 'likelyToMove',
    });
  if (data.resumeLastUpdated)
    filtersArray.push({
      tag: `Resume Updated: ${formattedDate(data.resumeLastUpdated)}`,
      id: 'resumeLastUpdated',
    });
  if (data.salaryRange?.currency)
    filtersArray.push({
      tag: `${data.salaryRange.min ?? ''} to ${data.salaryRange.max ?? ''} ${
        data.salaryRange.currency ?? ''
      } ${data.salaryRange.unitTime ?? ''}`,
      id: 'salaryRange',
    });
  if (!isEmpty(data.skills.values))
    filtersArray.push({
      tag: `Skills: ${data.skills.values.join(',')}`,
      id: 'skills',
    });
  if (!isEmpty(data.totalExperience?.min))
    filtersArray.push({
      tag: `Experience: ${data.totalExperience.min}-${data.totalExperience.max}`,
      id: 'totalExperience',
    });
  if (data.travelPreference.toString() !== '-1')
    filtersArray.push({
      tag: `Travel Pref.: ${data.travelPreference}`,
      id: 'travelPreference',
    });
  if (data.willingToRelocate)
    filtersArray.push({
      tag: `Willing To Relocate`,
      id: 'willingToRelocate',
    });
  if (data.willingToRelocateIncludeLocals)
    filtersArray.push({
      tag: `Willing to relocate+Locals`,
      id: 'willingToRelocateIncludeLocals',
    });
  if (data.willingToRelocatePreferredLocationsOnly)
    filtersArray.push({
      tag: `Willing to relocate+Preferred`,
      id: 'willingToRelocatePreferredLocationsOnly',
    });
  if (!isEmpty(data.workAuthorization))
    filtersArray.push({
      tag: `Work Authorization: ${data.workAuthorization.join(',')}`,
      id: 'workAuthorization',
    });

  return filtersArray;
};

export const getDiceCandidateDeatails = (diceCandidate) => {
  const array = [
    {
      icon: <WsIconLocation />,
      label: getCandidateLocation(diceCandidate) ?? 'Not Available',
      tooltip: 'Candidate Locaion',
    },
    {
      icon: <WsIconJobOutline />,
      tooltip: 'Candidate Profile',
      label: `${diceCandidate.currentJobTitle}${
        diceCandidate.currentCompany ? '@ ' + diceCandidate.currentCompany : 'Not Available'
      }`,
    },
    {
      icon: <WsIconPosition />,
      label:
        (diceCandidate.yearsOfExperience && `${diceCandidate.yearsOfExperience} Year Experience`) ??
        'Not Available',
      tooltip: 'Candidate Experience',
    },
    {
      icon: <TbCurrentLocation size={16} color={WsColors.TertiaryShades700} />,
      tooltip: 'Relocation Preferences',
      label: getWillingToRelocate(diceCandidate) ?? 'Not Available',
    },
    {
      icon: <HiOutlineArchive size={16} color={WsColors.TertiaryShades700} />,
      tooltip: 'WORK Preferences',
      label: getWorkPreference(diceCandidate),
    },
    {
      icon: <WsIconVisa />,
      label: `${
        diceCandidate.workPermitLocations ? diceCandidate.workPermitLocations.join(', ') : ''
      } | ${diceCandidate.workPermitDocuments ? diceCandidate.workPermitDocuments.join(', ') : ''}`,
      tooltip: 'Authorization',
    },
    {
      icon: <WsIconCurrency />,
      label: getRate(diceCandidate) ?? 'Not Available',
      tooltip: 'Desired Salary',
    },
    {
      icon: <HiOutlineArchive size={16} color={WsColors.TertiaryShades700} />,
      label: `${getTravelPreference(diceCandidate)} Travel Preference`,
      tooltip: 'Travel Preference',
    },
    {
      icon: <WsIconLikeLocation />,
      label: `${diceCandidate.likelyToMoveScore.toString()} Likely To Move`,
      tooltip: 'Relocation',
    },
  ];
  return array;
};

export interface IDiceSeaarchStateProps {
  diceResponse: DiceSearchResponse;
  appliedFilters: IFilterList[];
  diceRequest: DiceSearch;
  showBotConfig: boolean;
  openSourceBot: boolean;
  showConfigPanel: boolean;
  openAdvanceFilter: boolean;
  loader: boolean;
}

export const defaultDiceSearchStateReq: IDiceSeaarchStateProps = {
  diceResponse: {} as DiceSearchResponse,
  appliedFilters: [],
  diceRequest: {} as DiceSearch,
  showBotConfig: false,
  openSourceBot: false,
  showConfigPanel: true,
  openAdvanceFilter: false,
  loader: false,
};

export const likelyToMoveOptions = [
  { label: 'Any', value: -1 },
  { label: 'Most Likely To Switch', value: 76 },
  { label: 'Possibly Willing To Switch', value: 26 },
  { label: 'Unlikely To Switch', value: 1 },
  { label: 'Willing To Switch Unknown', value: 0 },
];

export const educationCheckBoxOptions = {
  associate: 'Associate',
  bachelors: 'Bachelors',
  'high school': 'High School',
  masters: 'Masters',
  mba: 'MBA',
  'military service': 'Military Service',
  'pre bachelors': 'Pre Bachelors',
  'pre masters': 'Pre Masters',
  'vocational school': 'Vocational School',
};

export const languagesCheckBoxOptions = {
  English: 'English',
  Spanish: 'Spanish',
  French: 'French',
  German: 'German',
  Russian: 'Russian',
  Chinese: 'Chinese',
  Italian: 'Italian',
  Hindi: 'Hindi',
  Portuguese: 'Portuguese',
  Japanese: 'Japanese',
  Arabic: 'Arabic',
};

export const additionalFiltersCheckBoxOptions = {
  excludeThirdParty: 'Exclude Third Party',
  excludeFounders: 'Exclude Founders',
  hasPatent: 'Has Patent',
};

export const employmentTypeCheckBoxOptions = {
  'full-time': 'Full Time',
  'contract to hire - w2': 'Contract To Hire - W2',
  'contract - w2': 'Contract - W2',
  'contract - independent': 'Contract - Independent',
  'contract to hire - independent': 'Contract To Hire - Independent',
  'contract - corp-to-corp': 'Contract - Corp-To-Corp',
  'contract to hire - corp-to-corp': 'Contract To Hire - Corp-To-Corp',
  'part-time': 'Part-Time',
};

export const authorizedCountriesCheckBoxOptions = {
  us: 'US',
  uk: 'United Kingdom',
  ca: 'Canada',
  ie: 'Ireland',
  in: 'India',
  it: 'Italy',
  es: 'Spain',
  pl: 'Poland',
  br: 'Brazil',
  lt: 'Lithuania',
  pt: 'Portugal',
  ng: 'Nigeria',
  au: 'Australia',
  mx: 'Mexico',
  hu: 'Hungary',
};

export const workAuthorizationCheckBoxOptions = {
  'us citizenship': 'US Citizenship',
  'green card': 'Green Card',
  'have h1': 'Have H1',
  'employment auth document': 'Employment Auth Document',
  'need h1': 'Need H1',
  'tn permit holder': 'Tn Permit Holder',
};

export const compensationOptions = [
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'EUR', value: 'EUR' },
  { label: 'CAD', value: 'CAD' },
];

export const compensationTimeOptions = [
  { label: 'Yearly', value: 'yearly' },
  { label: 'Hourly', value: 'hourly' },
];

export const travelPreferenceOptions = [
  { label: 'Any', value: '-1' },
  { label: 'Upto 25%', value: '25' },
  { label: 'Upto 50%', value: '50' },
  { label: 'Upto 75%', value: '75' },
  { label: 'Upto 100%', value: '100' },
  { label: 'Prefers No Travel', value: '0' },
];
